export default __webpack_public_path__ + "static/media/logo-colored.a88679aa.png";